import React from 'react'
import { NumberConvert } from '../../../common/numberConvert'

const SaleTotalInfomation = ({ store, data }) => {
  return (
    <div className='bg-stone-600/60 rounded-md flex flex-col gap-5 p-5 duration-150'>
      
      <div className='flex flex-col gap-3'>
        <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
          {store} 처리 현황
        </div>
        <div>        
          <div className='flex justify-between'>
            <p>카드 건수</p>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data0))} 건</p>
          </div>
          <div className='flex justify-between'>
            <p>현금 건수</p>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data1))} 건</p>
          </div>
          <div className='flex justify-between'>
            <p>이체 건수</p>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data2))} 건</p>
          </div>
        </div>
      </div>

      <div className='flex flex-col gap-3'>
        <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
          판매 현황
        </div>
        <div>        
          <div className='flex justify-between'>
            <p>판매 건수</p>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data3))} 건</p>
          </div>
          <div className='flex justify-between'>
            <p>판매 수량</p>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data4))} 개</p>
          </div>
        </div>
      </div>

      <div className='flex flex-col gap-3'>
        <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
          서비스 현황
        </div>
        <div>        
          <div className='flex justify-between'>
            <p>서비스 건수</p>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data5))} 건</p>
          </div>
          <div className='flex justify-between'>
            <p>서비스 수량</p>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data6))} 개</p>
          </div>
        </div>
      </div>

      <div className='flex flex-col gap-3'>
        <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
          시연용 현황
        </div>
        <div>        
          <div className='flex justify-between'>
            <p>시연용 건수</p>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data7))} 건</p>
          </div>
          <div className='flex justify-between'>
            <p>시연용 수량</p>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data8))} 개</p>
          </div>
        </div>
      </div>

      <div className='flex flex-col gap-3'>
        <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
          총 처리 현황
        </div>
        <div className='flex justify-between'>
          <div className='flex justify-between'>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data3 + data.data5 + data.data7))} 건</p>
          </div>
          <p>|</p>
          <div className='flex justify-between'>
            <p className='pt-[1px] tracking-wider'>{NumberConvert(Number(data.data4 + data.data6 + data.data8))} 개</p>
          </div>
        </div>
      </div>
      
    </div>
  )
}

export default SaleTotalInfomation